import {Component, Mixins} from 'vue-property-decorator'
import {Action, Getter, State} from "vuex-class";

@Component
class storeMixin extends Mixins() {
  @State(state => state.user.TOKEN)
  TOKEN!: any;

  @State(state => state.app.language)
  language!: any;
}

export default storeMixin
